import { Redirect } from "@shetharp/gatsby-theme-polaroid";
import * as React from 'react';
export default {
  Redirect,
  React
};